import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetCompanyNameRequest as SchemaSetCompanyNameRequest } from '../schemas/SetCompanyNameRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyNameContentType = 'application/json' as const;
export type SetCompanyNameRequest = SchemaSetCompanyNameRequest;
export type SetCompanyNameResponses = LinkCommonErrorResponses & {};
export type SetCompanyNameResponseSuccess = undefined;
export type SetCompanyNameSearchParams = undefined;
export type SetCompanyNamePathParameters = undefined;
export const SetCompanyNameUrl = '/company/name' as const;
export const SetCompanyNameMethod = 'POST' as const;
export const getSetCompanyNameUrl = (_params?: SetCompanyNamePathParameters) => SetCompanyNameUrl;
